import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

interface IProps {
    open: boolean;
    onClose: (refresh: boolean) => void;
}

export default function OnboardStaffDialog(props: IProps) {
    const { open, onClose } = props;

    React.useEffect(() => {
        getData();
    }, []);

    const getData = async () => {



    }




    return (
        <Dialog
            open={open}
            onClose={() => onClose(false)}
            maxWidth="md"
            fullWidth
        >

            <DialogContent>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Typography variant="h1">Welcome to teamplanner 🎉</Typography>
                    </Grid>
                    <Grid item>
                        <Typography variant="body1">We're excited to have you on board. <b>teamplanner</b> is here to simplify leave planning and sickness tracking for your business, ensuring schedules stay organised and hassle-free.</Typography>
                    </Grid>
                    <Grid item>
                        <Typography variant="body1">The first step is to <b>invite your team members.</b> Once they join, they can request time off, and you'll have full visibility and control over holiday schedules. Getting started is easy—send invitations to your staff now and take the first step toward stress-free holiday planning.</Typography>
                    </Grid>
                    <Grid item alignContent="center">

                        <Grid item >
                            <Button href="/Staff" variant="contained">Invite Staff</Button></Grid>
                    </Grid>
                    <Grid item>
                        <Typography variant="body1">To see how everything works, check out our quick explainer video. It'll walk you through the essentials and help you get up and running in no time.</Typography>
                    </Grid>
                    <Grid item>


                        <iframe width="462" height="260" src="https://www.youtube.com/embed/48FAuNlVltI?si=eAHE3ipgRdcs4jUW" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>



                    </Grid>

                </Grid>

                <DialogActions>
                    <Button onClick={() => onClose(false)} variant="contained">Close</Button>
                    <Button onClick={() => onClose(true)} color="info">Don't show again</Button>

                </DialogActions>
            </DialogContent>
        </Dialog>
    );
}